import { render, staticRenderFns } from "./returnReasonStatistics.vue?vue&type=template&id=ad2a9ba8&scoped=true&"
import script from "./returnReasonStatistics.vue?vue&type=script&lang=js&"
export * from "./returnReasonStatistics.vue?vue&type=script&lang=js&"
import style0 from "./returnReasonStatistics.vue?vue&type=style&index=0&id=ad2a9ba8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2a9ba8",
  null
  
)

export default component.exports